import ReactMarkdown from 'react-markdown';
import { Column } from '@simplywallst/ui-core';
import {
  LocationContainerRow,
  LocationContentRow,
  StyledReactMarkdown,
  LocationHeader,
  MapContainer,
} from './styled';
import { OneColumnExpanded } from '../../styled';

interface Props {
  title?: string;
  subtitle?: string;
  markdownContent: string[];
}

export const Location = ({ title, subtitle, markdownContent }: Props) => {
  return (
    <LocationContainerRow justifyContent="center">
      <OneColumnExpanded>
        <LocationHeader data-cy-id="location">
          <h2>{title}</h2>
          <p>{subtitle}</p>
        </LocationHeader>
        <LocationContentRow>
          <Column colMd={6} displayFlex justifyContent="flex-end">
            <MapContainer
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3312.55073996668!2d151.20600791601765!3d-33.87546728065449!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b12ae3dbadd497f%3A0x9b81474c1724081e!2s320%20Pitt%20St%2C%20Sydney%20NSW%202000!5e0!3m2!1sen!2sau!4v1669675292563!5m2!1sen!2sau"
              width="300"
              height="200"
              loading="lazy"
            />
          </Column>
          <Column colMd={6}>
            <StyledReactMarkdown>
              <ReactMarkdown source={markdownContent[0]} />
            </StyledReactMarkdown>
          </Column>
        </LocationContentRow>
      </OneColumnExpanded>
    </LocationContainerRow>
  );
};
